export default {
    virtualEventUserEntity: {
        role: {
            moderator: 'moderator',
            presenter: 'presenter',
            roundTableHost: 'roundTableHost',
            roundTableParticipant: 'roundTableParticipant',
            virtualRoomHost: 'virtualRoomHost',
            virtualRoomParticipant: 'virtualRoomParticipant',
        },
        mode: {
            slide: 'slide',
            poster: 'poster',
            video: 'video',
            vote: 'vote',
        },
    },
    virtualEventSessionEntity: {
        status: {
            closed: 'closed',
            initial: 'initial',
            broadcasting: 'broadcasting',
            ended: 'ended',
        },
        type: {
            moderated: 'moderated',
            unmoderated: 'unmoderated',
        },
        mode: {
            speakerAndSlider: 'speakerAndSlider',
            panelDiscussion: 'panelDiscussion',
        },
        roomType: {
            moderated: 'moderated',
            roundTable: 'roundTable',
            virtual: 'virtual',
            default: null,
        },
    },

    requestStatus: {
        initial: 'initial',
        loading: 'loading',
        success: 'success',
        error: 'error',
    },
};
